/* istanbul ignore file */
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Route } from 'react-router-dom';
import { BudgetRouter } from './budget';
import { BudgetReportRouter } from './budget/report';
import { CostAccountingRouter } from './costAccounting';
import { ReconciliationRouter } from './costAccounting/reconcilation';
import { WasteRouter } from './costAccounting/waste';
import { AccountingCycleRouter } from './costAccounting/accountingCycle';
import { PayrollRouter } from './payroll';
import { GeneratedPayrollsRouter } from './payroll/generatedPayrolls';
import { PayrollDistributionRouter } from './payroll/payrollDistribution';
import { WorkingHoursRouter } from './workingHours';
import { LedgerRouter } from './ledger';
import { JournalEntryRouter } from './journalEntry';
import { InvoiceRouter } from './invoice';
import VendorRouter from './vendors/VendorRouter';
import { AssetRouter } from './assets';
import { ExpenseRouter } from './expenses';
import { PurchaseOrderRouter } from './purchaseOrder';

const FinanceRouter = () => {
  const { isAuthenticated } = useAuthenticationService();

  return [
    <Route path={BudgetRouter.getRouterPath()} element={<BudgetRouter />} />,
    <Route path={BudgetReportRouter.getRouterPath()} element={<BudgetReportRouter />} />,
    <Route path={CostAccountingRouter.getRouterPath()} element={<CostAccountingRouter />} />,
    <Route path={ReconciliationRouter.getRouterPath()} element={<ReconciliationRouter />} />,
    <Route path={WasteRouter.getRouterPath()} element={<WasteRouter />} />,
    <Route path={AccountingCycleRouter.getRouterPath()} element={<AccountingCycleRouter />} />,
    <Route path={PayrollRouter.getRouterPath()} element={<PayrollRouter />} />,
    <Route path={GeneratedPayrollsRouter.getRouterPath()} element={<GeneratedPayrollsRouter />} />,
    <Route path={PayrollDistributionRouter.getRouterPath()} element={<PayrollDistributionRouter />} />,
    <Route path={WorkingHoursRouter.getRouterPath()} element={<WorkingHoursRouter />} />,
    <Route path={LedgerRouter.getRouterPath()} element={<LedgerRouter />} />,
    <Route path={JournalEntryRouter.getRouterPath()} element={<JournalEntryRouter />} />,
    <Route path={InvoiceRouter.getRouterPath()} element={<InvoiceRouter />} />,
    <Route path={VendorRouter.getRouterPath()} element={<VendorRouter />} />,
    <Route path={AssetRouter.getRouterPath()} element={<AssetRouter />} />,
    <Route path={ExpenseRouter.getRouterPath()} element={<ExpenseRouter />} />,
    <Route path={PurchaseOrderRouter.getRouterPath()} element={<PurchaseOrderRouter />} />,
    <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />,
  ];
};

export default FinanceRouter;
